// Настройки hero-картинки. Меняй значения здесь — стили подхватят автоматически.

const LOGIN = {
  top: 140,
  objectFit: "contain",
  objectPositionX: "0%",
  objectPositionY: "100%",
  scale: 1.2,
  scaleOrigin: "right bottom",
};

const REGISTER = {
  objectFit: "cover",
  objectPositionX: "center", // center | left | right
  objectPositionY: "bottom", // bottom | center | top
  scale: 1,
  scaleOrigin: "center bottom",
};

export const AUTH_HERO_IMAGE = {
  login: LOGIN,
  recovery: LOGIN,
  register: REGISTER,
};

const buildTransform = ({ scale, scaleOrigin }) => {
  if (!scale || scale === 1) return "";
  return `
    transform: scale(${scale});
    transform-origin: ${scaleOrigin};
  `;
};

export const getAuthHeroImageCss = (variant) => {
  const cfg = AUTH_HERO_IMAGE[variant] ?? AUTH_HERO_IMAGE.login;

  if (variant === "register") {
    return `
      inset: 0;
      width: 100%;
      height: 100%;
      object-fit: ${cfg.objectFit};
      object-position: ${cfg.objectPositionX} ${cfg.objectPositionY};
      ${buildTransform(cfg)}
    `;
  }

  return `
    left: 0;
    right: 0;
    bottom: 0;
    top: ${cfg.top}px;
    width: 100%;
    height: calc(100% - ${cfg.top}px);
    object-fit: ${cfg.objectFit};
    object-position: ${cfg.objectPositionX} ${cfg.objectPositionY};
    ${buildTransform(cfg)}
  `;
};
